import { render, staticRenderFns } from "./AdminDelete.vue?vue&type=template&id=27551efb&"
import script from "./AdminDelete.vue?vue&type=script&lang=js&"
export * from "./AdminDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports